import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useVoucherRefundStatusReducer = () => useSelector((state: ApplicationState) => state.voucherRefundStatus);
